export const exploreDesignFields = {
    NEW_IN: true,
    SOLD: true,
    DESIGN_LOOK: true,
    CATEGORY: true,
    SEASON: true,
    FABRIC: true,
    COMPOSITION: true,
    DEPARTMENT: true,
    PRICE_RANGE: true
}

export const imageSearchFilterFields = {
    CATEGORY: true,
    SEASON: true,
    FABRIC: true
}

export const sharedCollectionFields = {
    DESIGNERS_PICK: true,
    CATEGORY: true,
    SEASON: true,
    DEPARTMENT: true,
    DESIGN_LOOK: true,
    FABRIC: true,
    COMPOSITION: true,
    PRICE_RANGE: true
}

export const filterTypes = {
    NEW_IN: 'New In',
    AGE_GROUP: 'Age Group',
    DESIGN_LOOK: 'Design Look',
    CATEGORY: 'Category',
    SEASON: 'Season',
    FABRIC: 'Fabric',
    DEPARTMENT: 'Department',
    COMPOSITION: 'Composition',
    PRICE_RANGE: 'Price Range'
}

const processIds = (filters, item, str) => {
    let tmpIds = filters[item]?.map((obj) => obj.id)
    str += `${tmpIds.join(',')}`
    return str
}

const mapFilterItems = (filters, newFilters) => {
    for (const item in filters) {
        if (Array.isArray(filters[item])) {
            switch (item) {
                case 'subCategories':
                    newFilters.subCategoryIdList = filters[item].map(
                        (obj) => obj.id
                    )
                    break
                case 'seasons':
                    newFilters.seasonList = filters[item].map((obj) => obj.id)
                    break
                case 'ageGroups':
                    newFilters.ageGroups = filters[item].map((obj) => obj.id)
                    break
                case 'designLooks':
                    newFilters.designLookList = filters[item].map(
                        (obj) => obj.id
                    )
                    break
                case 'fabrics':
                    newFilters.constructionList = filters[item]
                        .map((fabric) => fabric.constructions)
                        .flat()
                    break
                case 'departments':
                    newFilters.marketIdList = filters[item].map((obj) => obj.id)
                    break
                case 'composition':
                    newFilters.compositionPartDTOList = filters[item].map(
                        (comp) => ({
                            fiberName: comp?.fiberName,
                            minPercentage: Number(comp?.minPercentage),
                            maxPercentage: Number(comp?.maxPercentage)
                        })
                    )
                    break
                case 'priceRange':
                    newFilters.offerPriceList = filters[item].map((price) => ({
                        brandId: price.brandId,
                        minPrice: Number(price?.minPrice),
                        maxPrice: Number(price?.maxPrice)
                    }))
                    break
            }
        } else {
            switch (item) {
                case 'categoryList':
                    newFilters.categoryIdList = [filters[item].id]
                    break
                case 'mainFabricList':
                    newFilters.baseMaterialId = filters[item].id
                    break
                case 'availabilityStatus':
                    newFilters.isSoldDesignerStyle = true
                    break
                case 'isNew':
                case 'isMoreExplore':
                case 'designersPick':
                case 'recentlyShared':
                    newFilters[item] = filters[item].value
                    break
            }
        }
    }
}

export const generateExploreDesignPageParams = (filters) => {
    let newFilters = {}
    mapFilterItems(filters, newFilters)
    if (Object.keys(newFilters).length > 0) {
        newFilters.isFilterAvailable = true
    }

    return newFilters
}

export const generateSharedCollectionPageParams = (filters) => {
    let newFilters = {}
    mapFilterItems(filters, newFilters)
    return newFilters
}
